import jQuery from "jquery";
import { EVENT, countryCode } from "../data/constants";
import DATA from "../data/data";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import { DistanceProvider } from "../stores-js/location/distanceprovider";
import { SearchParameters } from "../stores-js/searchparameters";
import { OriginDestinationInput } from "../stores-js/ui/origindestinationinput";
import templates from "../templates";
import {
    EventManager,
    addBrandIconMarker,
    concatenateStoreAddress,
    concatenateStoreHours,
    createWoosmapDirectionsProvider,
    formatDistanceValue,
    formatStoreDistanceValue,
    generateMarkersStyleRules,
    generateSearchQuery,
    open247,
} from "../utils/global";

const $ = jQuery;

export default class MapView extends woosmap.map.MVCObject {
    constructor(mainView, brands, country, filters, mapSearchQuery, callback) {
        super();
        this.selector = "#storemap-map-container";
        this.country = country;
        this.mainView = mainView;

        this.mainElement = $(this.selector);
        this.mainElement.html(
            templates.mobile.map.render({
                ui: total.maps.L10n.ui,
                itinerary: SETTINGS.itinerary,
            }),
        );
        this.googleMapSelector = "#storemap-map-canvas";
        this.map = null;
        this.storesOverlay = null;
        this.searchParameters = new SearchParameters();
        this.brands = brands;
        this.filters = filters;
        this.initialBounds = null;
        this.stores = null;
        this.selectedStore = null;
        this.directions = null;
        this.directionsRenderers = null;
        this.location = null;

        this.is_center_changed = false;
        this.searchStores = null;
        this.data = new woosmap.map.Data();
        this.data.setMap(this.map);
        // Direction

        this.woosmapOriginDestinationInput = new OriginDestinationInput(templates.mobile.direction.render(), {
            geolocText: total.maps.L10n.ui.common.myLocation,
        });

        // Add system metric
        const googleDirectionsRequestOptions = $.extend(SETTINGS.googleDirectionsRequestOptions, {
            unitSystem: google.maps.UnitSystem.METRIC,
        });

        // this.woosmapDirectionsProvider = new DirectionsProvider(SETTINGS.directionRendererOptions, googleDirectionsRequestOptions, (() => {
        //   // erreur lors du calcul des directions, point non atteignable, moyen de transport non disponible
        //   self.mainView.onDirectionsChange([]);
        // }));

        this.woosmapDirectionsProvider = createWoosmapDirectionsProvider(
            SETTINGS.directionRendererOptions,
            googleDirectionsRequestOptions,
            () => {
                this.mainView.onDirectionsChange([]);
            },
        );

        this.woosmapDirectionsProvider.bindTo("originDestination", this.woosmapOriginDestinationInput);
        this.woosmapDirectionsProvider.set("selectedTravelMode", "DRIVING");

        this.bindTo("directionsSummaries", this.woosmapDirectionsProvider);
        this.bindTo("directionsRenderers", this.woosmapDirectionsProvider);
        this.bindTo("originDestination", this.woosmapOriginDestinationInput);

        this.woosmapDistanceProvider = new DistanceProvider();

        this._initializeMap(country, mapSearchQuery, () => {
            this._filter();
            woosmap.map.event.addListener(this.storesOverlay, "store_selected", (storeData) => {
                this.set("selectedStore", storeData);
            });

            /*
            this.woosmapDirectionsResultsDisplayer = new DirectionsResultsDisplayer(this.map, '', (() => {}));

            this.woosmapDirectionsResultsDisplayer.bindTo('directionsSummaries', this.woosmapDirectionsProvider);
            this.woosmapDirectionsResultsDisplayer.bindTo('directionsRenderers', this.woosmapDirectionsProvider);
      */
            callback(this);
        });
        this._wireEvents();

        // Geolocalisation

        this.firstTimeShow = true;
        this.storeSlideCurrentIndex = 0;
        this.directionSlideCurrentIndex = 0;
    }

    _initializeMap(country, mapSearchQuery, callback) {
        const { mapStyles } = SETTINGS;
        const mapOptions = {
            center: new google.maps.LatLng(0, 0),
            zoom: 1,
            disableDefaultUI: true,
            styles: mapStyles,
            gestureHandling: "greedy",
            // scrollwheel: SETTINGS.enableScrollWheel,
        };

        this.map = new google.maps.Map($(this.googleMapSelector).get(0), mapOptions);

        const styleRules = generateMarkersStyleRules();

        this.storesOverlay = new woosmap.map.StoresOverlay(styleRules);
        this.storesOverlay.setMap(this.map);

        this.locationMarker = new woosmap.map.Marker({
            icon: {
                url: `${SETTINGS.serverUrl}css/images/map-icons/position.png`,
                scaledSize: new google.maps.Size(40, 40),
                anchor: new google.maps.Point(20, 20),
            },
        });

        if (this.country && !mapSearchQuery) {
            if (country.toUpperCase() === "TW") {
                const { boundsTW } = total.maps.constant;
                this.initialBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(boundsTW.south, boundsTW.west),
                    new google.maps.LatLng(boundsTW.north, boundsTW.east),
                );
                callback();
            } else {
                const wantedCountry = countryCode[country.toUpperCase()];
                DATA.getBoundsForCountry(wantedCountry, (viewport) => {
                    this.initialBounds = {
                        east: viewport.northeast.lng,
                        south: viewport.southwest.lat,
                        north: viewport.northeast.lat,
                        west: viewport.southwest.lng,
                    };
                    this.map.fitBounds(this.initialBounds);
                    callback();
                });
            }
        } else {
            const bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(-70, -180),
                new google.maps.LatLng(70, 180),
            );
            this.initialBounds = bounds;
            callback();
        }
    }

    _filter() {
        let tagQuery;
        const q = woosmap.map.query;

        if (this.filters) {
            const tagFields = [];

            for (const filter of this.filters) {
                const partial = q.F("tag", filter);
                tagFields.push(partial);
            }
            tagQuery = new woosmap.map.query.Query(tagFields, "AND");
        }

        let typeQuery;
        const typeFields = [];

        for (const filter of SERVICE_REGISTRY.queryService.getTypeArray()) {
            const partial = q.F("type", filter.value);
            typeFields.push(partial);
        }
        if (typeFields.length > 0) {
            typeQuery = new woosmap.map.query.Query(typeFields, "OR");
        }

        if (tagQuery && typeQuery) {
            this.searchParameters.query = woosmap.map.query.and([tagQuery, typeQuery]);
        } else if (tagQuery) {
            this.searchParameters.query = tagQuery;
        } else if (typeQuery) {
            this.searchParameters.query = typeQuery;
        }
    }

    onCenterChange(callback) {
        if (this.centerChangeCallback) throw new Error("bounds change callback already registered");
        this.centerChangeCallback = callback;
    }

    _handleMapCenterChanged() {
        this.is_center_changed = true;
        this.centerChangeCallback();
    }

    _wireEvents() {
        const self = this;

        $("#storemap-map-plusbutton").click(() => {
            this._zoomIn();
        });
        $("#storemap-map-minusbutton").click(() => {
            this._zoomOut();
        });
        $(".storemap-map-button-content").click(() => {
            onGeolocationButtonClick();
        });

        this.map.addListener(this.map, "center_changed", (event) => {
            this._handleMapCenterChanged(event);
        });
        function handleStoreSelectionOnRoute(store) {
            for (const feature of Object.values(self.data._features)) {
                feature.removeProperty("highlighted");
            }
            const featureToHighlight = self.data.getFeatureById(store.properties.store_id);
            if (featureToHighlight) {
                featureToHighlight.setProperty("highlighted", true);
            }
        }

        function onSlideStoreNextArrowClick(event) {
            self.storeSlideCurrentIndex = (Number.parseInt(self.storeSlideCurrentIndex, 10) + 1) % self.stores.length;
            self._hydrateStoreSlider(self.stores[self.storeSlideCurrentIndex]);
            const store = self.stores[self.storeSlideCurrentIndex];
            self.storesOverlay.setSelection(store);
            self.map.panTo({
                lat: store.geometry.coordinates[1],
                lng: store.geometry.coordinates[0],
            });
            handleStoreSelectionOnRoute(store);
            event.stopPropagation();
            return false;
        }

        function onSlideStorePreviousArrowClick(event) {
            self.storeSlideCurrentIndex =
                (((Number.parseInt(self.storeSlideCurrentIndex, 10) - 1) % self.stores.length) + self.stores.length) %
                self.stores.length;
            self._hydrateStoreSlider(self.stores[self.storeSlideCurrentIndex]);
            const store = self.stores[self.storeSlideCurrentIndex];
            self.storesOverlay.setSelection(store);
            self.map.panTo({
                lat: store.geometry.coordinates[1],
                lng: store.geometry.coordinates[0],
            });
            handleStoreSelectionOnRoute(store);
            event.stopPropagation();
            return false;
        }

        function onDirectionNextArrowClick(event) {
            self.directionSlideCurrentIndex =
                (Number.parseInt(self.directionSlideCurrentIndex, 10) + 1) % self.directions.length;
            self._hydrateDirectionSlider(
                self.directions[self.directionSlideCurrentIndex],
                self.directionSlideCurrentIndex,
            );
            self._changeDirectionMapDisplayIndex(self.directionSlideCurrentIndex);
            event.stopPropagation();
            return false;
        }

        function onDirectionStorePreviousArrowClick(event) {
            self.directionSlideCurrentIndex =
                (((Number.parseInt(self.directionSlideCurrentIndex, 10) - 1) % self.directions.length) +
                    self.directions.length) %
                self.directions.length;
            self._hydrateDirectionSlider(
                self.directions[self.directionSlideCurrentIndex],
                self.directionSlideCurrentIndex,
            );
            self._changeDirectionMapDisplayIndex(self.directionSlideCurrentIndex);
            event.stopPropagation();
            return false;
        }

        function onSlideStoreContainerClick() {
            self.mainView.setStoreDetails(self.stores[self.storeSlideCurrentIndex]);
            self.mainView.showDetail();
            // eslint-disable-next-line no-restricted-globals
            event.stopPropagation();
            EventManager.notify(
                EVENT.MORE_INFORMATION_CLICKED,
                self.stores[self.storeSlideCurrentIndex].properties.store_id,
            );
            return false;
        }

        function onGoButtonClick(event) {
            self.mainView.showDirection();
            event.stopPropagation();
            EventManager.notify(EVENT.GO_CLICKED, self.tiledView.get("selectedStore").properties.store_id);
            return false;
        }

        function onGoogleMapsButtonClick(event) {
            const directionUrl = self.generateGoogleMapsDirectionUrl(self.directionSlideCurrentIndex);
            window.open(directionUrl, "_blank");
            EventManager.notify(EVENT.NAVIGATION_CLICKED);
            event.preventDefault();
            event.stopPropagation();
            return false;
        }

        function onPhoneButtonClick() {
            EventManager.notify(EVENT.CALL_CLICKED);
        }

        function onGeolocationButtonClick() {
            self.mainView.getNavigatorLocation((position) => {
                if (position) {
                    const newPosition = position;
                    newPosition.description = total.maps.L10n.ui.common.myLocation;
                    self.updateMainLocation(position);
                    SERVICE_REGISTRY.locationService.setLocation(newPosition, newPosition.description);
                    self.mainView.setSearchViewInputSearchText(newPosition.description);
                    setTimeout(() => {
                        self.mainView.showMap("store");
                    }, 500);
                }
            });

            EventManager.notify(EVENT.GEOLOCATION_CLICKED);
        }

        function onCancelDirectionButtonClick(event) {
            self.mainView.showDirection();
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        function handleTouchMove(e, callback) {
            if (!xStart || !yStart) {
                return;
            }

            const xEnd = e.touches[0].clientX;
            const yEnd = e.touches[0].clientY;

            const xDiff = xStart - xEnd;
            const yDiff = yStart - yEnd;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff > 0) {
                    console.log("Swipe left");
                    callback(e);
                    // Do something for swipe left
                } else {
                    console.log("Swipe right");
                    callback(e);
                    // Do something for swipe right
                }
            } else {
                if (yDiff > 0) {
                    console.log("Swipe up");
                    // Do something for swipe up
                } else {
                    console.log("Swipe down");
                    // Do something for swipe down
                }
            }
            xStart = null;
            yStart = null;
        }
        let xStart = null;
        let yStart = null;
        let touchStartTime = 0;
        let isSwipe = false;
        function handleTouchStart(e) {
            const firstTouch = e.touches[0];
            xStart = firstTouch.clientX;
            yStart = firstTouch.clientY;
            touchStartTime = Date.now();
            isSwipe = false;
        }
        function handleTouchEnd(e, callback) {
            const touchDuration = Date.now() - touchStartTime;

            if (!isSwipe && touchDuration < 200) {
                console.log("Tap detected");
                callback(e);
            } else if (isSwipe) {
                console.log("Swipe detected");
            }

            xStart = null;
            yStart = null;
        }

        const nextDirectionElement = this.mainElement.find(
            ".storemap-maproaditem-container .storemap-maproaditem-next",
        )[0];
        if (nextDirectionElement) {
            nextDirectionElement.addEventListener("touchstart", handleTouchStart, false);
            nextDirectionElement.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onDirectionNextArrowClick);
                },
                false,
            );
        }
        const prevDirectionElement = this.mainElement.find(
            ".storemap-maproaditem-container .storemap-maproaditem-previous",
        )[0];
        if (prevDirectionElement) {
            prevDirectionElement.addEventListener("touchstart", handleTouchStart, false);
            prevDirectionElement.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onDirectionStorePreviousArrowClick);
                },
                false,
            );
        }
        const googleButton = this.mainElement.find(".storemap-maproaditem-google-button")[0];
        if (googleButton) {
            googleButton.addEventListener("touchstart", handleTouchStart, false);
            googleButton.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onGoogleMapsButtonClick);
                },
                false,
            );
        }
        const directionsContainer = this.mainElement.find(".storemap-maproaditem-container")[0];
        if (directionsContainer) {
            directionsContainer.addEventListener(
                "touchmove",
                (e) => {
                    handleTouchMove(e, onDirectionNextArrowClick);
                },
                false,
            );
        }
        const cancelDirections = this.mainElement.find(".storemap-maproaditem-cancel-button")[0];
        if (cancelDirections) {
            cancelDirections.addEventListener("touchstart", handleTouchStart, false);
            cancelDirections.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onCancelDirectionButtonClick);
                },
                false,
            );
        }

        const storeMapListContainerNextArrow = this.mainElement.find(
            ".storemap-maplistitem-container .storemap-maplistitem-next",
        )[0];
        if (storeMapListContainerNextArrow) {
            storeMapListContainerNextArrow.addEventListener("touchstart", handleTouchStart, false);
            storeMapListContainerNextArrow.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onSlideStoreNextArrowClick);
                },
                false,
            );
        }

        const storeMapListContainerPrevArrow = this.mainElement.find(
            ".storemap-maplistitem-container .storemap-maplistitem-previous",
        )[0];
        if (storeMapListContainerPrevArrow) {
            storeMapListContainerPrevArrow.addEventListener("touchstart", handleTouchStart, false);
            storeMapListContainerPrevArrow.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onSlideStorePreviousArrowClick);
                },
                false,
            );
        }
        const storeMapListContainer = this.mainElement.find(".storemap-maplistitem-container")[0];
        if (storeMapListContainer) {
            storeMapListContainer.addEventListener("touchstart", handleTouchStart, false);
            storeMapListContainer.addEventListener(
                "touchend",
                (e) => {
                    handleTouchEnd(e, onSlideStoreContainerClick);
                },
                false,
            );
        }
        // this.mainElement.find('.storemap-maproaditem-container').swipe({
        //   swipeRight: onDirectionNextArrowClick,
        //   swipeLeft: onDirectionStorePreviousArrowClick,
        //   tap: onSlideStoreContainerClick,
        // });
        //
        // this.mainElement.find('.storemap-maproaditem-container .storemap-maproaditem-next').swipe({
        //   tap: onDirectionNextArrowClick,
        // });
        //
        // this.mainElement.find('.storemap-maproaditem-container .storemap-maproaditem-previous').swipe({
        //   tap: onDirectionStorePreviousArrowClick,
        // });
        //
        // this.mainElement.find('.storemap-maplistitem-direction-button').swipe({
        //   tap: onGoButtonClick,
        // });
        //
        // this.mainElement.find('.storemap-maproaditem-google-button').swipe({
        //   tap: onGoogleMapsButtonClick,
        // });
        //
        // this.mainElement.find('.storemap-maproaditem-waze-button').swipe({
        //   tap: onGoogleMapsButtonClick,
        // });
        //
        //
        // this.mainElement.find('#storemap-map-positionbutton').swipe({
        //   tap: onGeolocationButtonClick,
        // });
        //
        // this.mainElement.find('.storemap-maproaditem-cancel-button').swipe({
        //   tap: onCancelDirectionButtonClick,
        // });

        this.mainElement.find(".storemap-maplistitem-telephone-button").click(onPhoneButtonClick);
    }

    /** **********************************************************************************************************
     *                                                   Map control                                            *
     *********************************************************************************************************** */

    _zoomIn() {
        this.map.setZoom(this.map.getZoom() + 1);
    }

    _zoomOut() {
        this.map.setZoom(this.map.getZoom() - 1);
    }

    show(sliderName, index, country) {
        this.mainElement.show();
        let bounds;
        const storesContainer = this.mainElement.find(".storemap-maplistitem-container");
        const directionsContainer = this.mainElement.find(".storemap-maproaditem-container");

        if (sliderName === "store" && $.isArray(this.stores) && this.stores.length !== 0) {
            storesContainer.show();
            directionsContainer.hide();
            google.maps.event.trigger(this.map, "resize");

            if (this.stores.length === 1) {
                storesContainer.find(".storemap-maplistitem-previous").hide();
                storesContainer.find(".storemap-maplistitem-next").hide();
            } else {
                storesContainer.find(".storemap-maplistitem-previous").show();
                storesContainer.find(".storemap-maplistitem-next").show();
            }
            const bottomMove = storesContainer[0]?.clientHeight + 20;
            bounds = this.calculateLatLngBounds(this.stores);
            this.map.fitBounds(bounds, { bottom: bottomMove });
        } else if (sliderName === "direction") {
            this.mainElement.find(".storemap-maplistitem-container").hide();
            if (this.directions !== null && index >= 0 && index < this.directions.length) {
                if (this.directions.length === 1) {
                    directionsContainer.find(".storemap-maproaditem-previous").hide();
                    directionsContainer.find(".storemap-maproaditem-next").hide();
                } else {
                    directionsContainer.find(".storemap-maproaditem-previous").show();
                    directionsContainer.find(".storemap-maproaditem-next").show();
                }

                directionsContainer.show();
                this.directionSlideCurrentIndex = index;
                this._hydrateDirectionSlider(this.directions[index], index);
                this._changeDirectionMapDisplayIndex(index);
            } else {
                directionsContainer.hide();
            }
        } else {
            this.mainElement.find(".storemap-maplistitem-container").hide();
            this.mainElement.find(".storemap-maproaditem-container").hide();
        }

        if (this.firstTimeShow) {
            // correction lié au problème de non affichage d'une google map initialisé dans un element en display none
            // http://stackoverflow.com/questions/4700594/google-maps-displaynone-problem
            google.maps.event.trigger(this.map, "resize");

            if (sliderName === "store" && $.isArray(this.stores) && this.stores.length !== 0) {
                bounds = new google.maps.LatLngBounds();
                for (const store of this.stores) {
                    bounds.extend(new google.maps.LatLng(store.geometry.coordinates[1], store.geometry.coordinates[0]));
                }
                this.map.fitBounds(bounds);
            } else if (sliderName === "direction") {
                this.mainElement.find(".storemap-maplistitem-container").hide();
                if (this.directions !== null && index >= 0 && index < this.directions.length) {
                    this.mainElement.find(".storemap-maproaditem-container").show();
                    this.directionSlideCurrentIndex = index;
                    this._hydrateDirectionSlider(this.directions[index], index);
                    this._changeDirectionMapDisplayIndex(index);
                } else {
                    this.mainElement.find(".storemap-maproaditem-container").hide();
                }
            } else if (this.selectedStore?.geometry?.coordinates) {
                this.map.setCenter(
                    new google.maps.LatLng(
                        this.selectedStore.geometry.coordinates[1],
                        this.selectedStore.geometry.coordinates[0],
                    ),
                );
                this.map.setZoom(16);
            } else {
                if (country && country.toUpperCase() === "TW") {
                    google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
                        this.map.setZoom(7);
                    });
                }
                this.map.fitBounds(this.initialBounds);
            }
            this.firstTimeShow = false;
        }
    }
    calculateLatLngBounds(stores) {
        const bounds = new woosmap.map.LatLngBounds();
        if (SERVICE_REGISTRY.itinaryService.getOrigin()) {
            const origin = SERVICE_REGISTRY.itinaryService.getOrigin();
            bounds.extend(new woosmap.map.LatLng(origin.lat, origin.lng));
        }
        for (const store of stores) {
            bounds.extend(new woosmap.map.LatLng(store.geometry.coordinates[1], store.geometry.coordinates[0]));
        }
        if (SERVICE_REGISTRY.itinaryService.getDestination()) {
            const dest = SERVICE_REGISTRY.itinaryService.getDestination();
            bounds.extend(new woosmap.map.LatLng(dest.lat, dest.lng));
        }
        return bounds;
    }

    hide() {
        this.mainElement.hide();
    }

    _changeDirectionMapDisplayIndex(index) {
        this.get("directionsRenderers")[index].renderer.setRouteIndex(index);

        // this.woosmapDirectionsResultsDisplayer.cleanMapFromRoutes();
        // this.woosmapDirectionsResultsDisplayer.displayRouteOnMap(index);

        // google.maps.event.trigger(this.map, 'resize');

        // this.woosmapDirectionsResultsDisplayer.displayRouteOnMap(index);
        // const computedDirections = this.woosmapDirectionsResultsDisplayer.get('directionsRenderers')[index].getDirections();
    }

    clearDirectionMap() {
        // this.woosmapDirectionsResultsDisplayer.cleanMapFromRoutes();
        const renderers = this.directionsProvider?.get("directionsRenderers");
        if (renderers) {
            for (const e of renderers) {
                e.map = null;
            }
        }
        // this.updateUserDirectionLocation({});
        this.updateUserDirectionLocation(null);
        this.mainElement.find(".storemap-maproaditem-container").hide();
        if (Array.isArray(this.stores) && this.stores.length !== 0) {
            this.mainElement.find(".storemap-maplistitem-container").show();
            this.mainView.showMap("store");
        }
    }

    /** **********************************************************************************************************
     *                                               Getter Setter                                              *
     *********************************************************************************************************** */

    updateDirectionTravelMode(travelMode) {
        this.woosmapDirectionsProvider.set("selectedTravelMode", travelMode);
    }

    getDirectionTravelMode() {
        return this.woosmapDirectionsProvider.get("selectedTravelMode");
    }

    toggleOriginDestination() {
        if (this.woosmapOriginDestinationInput._isGeoloc === "origin") {
            this.woosmapOriginDestinationInput._isGeoloc = "destination";
        } else if (this.woosmapOriginDestinationInput._isGeoloc === "destination") {
            this.woosmapOriginDestinationInput._isGeoloc = "origin";
        }

        const originDestination = this.woosmapOriginDestinationInput.get("originDestination");

        if (originDestination) {
            this.woosmapOriginDestinationInput.set("originDestination", {
                origin: originDestination.destination,
                destination: originDestination.origin,
            });
        }

        this.woosmapOriginDestinationInput.updateOriginDestination();
    }

    setStores(stores) {
        this.stores = stores;
    }

    updateMainLocation(location) {
        this.location = location;
        this.location.lat = Number.parseFloat(location.lat);
        this.location.lng = Number.parseFloat(location.lng);
        this.locationMarker.setPosition(this.location);
    }

    getMainLocation() {
        return this.location;
    }

    clearMainLocation() {
        this.location = {};
        this.locationMarker.setMap(null);
        this.stores = [];
        this.resetOnRouteView();
    }
    resetOnRouteView() {
        if (this.storesOverlay.getMap() === null) {
            this.data.setMap(null);
            this.storesOverlay.setMap(this.map);
        }
    }
    getSelectedStore() {
        return this.selectedStore;
    }

    setSelectedStore(store) {
        this.storesOverlay.setSelection(store);
        this.selectedStore = store;
        this.map.panTo({
            lat: store.geometry.coordinates[1],
            lng: store.geometry.coordinates[0],
        });
    }

    updateUserDirectionLocation(location) {
        // this.location.lat = parseFloat(location.lat);
        // this.location.lng = parseFloat(location.lng);
        this.woosmapOriginDestinationInput.set("location", location);
    }
    updateDestination(store) {
        this.woosmapOriginDestinationInput.set("selectedStore", store);
    }

    /** **********************************************************************************************************
     *                                                   Utils                                                  *
     *********************************************************************************************************** */

    generateGoogleMapsDirectionUrl(index) {
        const travelMode = this.woosmapDirectionsProvider.get("selectedTravelMode");
        const directionRenderer = this.get("directionsRenderers");

        if (!directionRenderer || index < 0 || index >= directionRenderer.length)
            throw new Error("Direction index invalid");

        const urlDataTravelModeAndIndexCode = {
            WALKING: "!3e2",
            BICYCLING: "!3e1",
            DRIVING: "!3e0",
            TRANSIT: "!3e3",
        };

        const googleMapDirectionBaseUrl = "https://www.google.com/maps/dir/";
        const direction = directionRenderer[index];
        const { origin } = direction.directions.request;
        const { destination } = direction.directions.request;

        const orgArr = origin.split(",");
        const destArr = destination.split(",");

        let directionUrl = googleMapDirectionBaseUrl;
        directionUrl += `${orgArr[1]},${origin[0]}/`;
        directionUrl += `${destArr[1]},${destArr[0]}/`;

        if (Number.parseInt(index, 10) === 0) {
            directionUrl += `data=!4m2!4m1${urlDataTravelModeAndIndexCode[travelMode]}`;
        } else {
            directionUrl += `data=!4m3!4m2${urlDataTravelModeAndIndexCode[travelMode]}!5i${Number.parseInt(index, 10)}`;
        }

        return directionUrl;
    }

    generateWazeDirectionUrl(index) {
        const directionRenderer = this.get("directionsRenderers");

        if (!directionRenderer || index < 0 || index >= directionRenderer.length)
            throw new Error("Direction index invalid");

        const direction = directionRenderer[index];
        const { destination } = direction.directions.request;
        const destArr = destination.split(",");
        const destinationCoordinates = new woosmap.map.LatLng(destArr[1], destArr[0]);
        return `waze://?ll=${destinationCoordinates.lat()},${destinationCoordinates.lng()}&navigate=yes`;
    }

    /** **********************************************************************************************************
     *                                               MVC Object Events                                          *
     *********************************************************************************************************** */

    selectedStore_changed() {
        const selectedStore = this.get("selectedStore");

        if (selectedStore?.properties?.store_id) {
            EventManager.notify(EVENT.STORE_CLICKED, selectedStore.properties.store_id);
        }

        if ($.isArray(this.stores) && this.stores.length !== 0) {
            this.stores.forEach((store, index) => {
                if (store.properties && selectedStore.properties.store_id === store.properties.store_id) {
                    this.storeSlideCurrentIndex = index;
                    this._hydrateStoreSlider(store);
                    this.woosmapOriginDestinationInput.set("selectedStore", store);
                }
            });
        } else {
            this.mainView.setStoreDetails(selectedStore);
            this.mainView.showDetail();
            this.woosmapOriginDestinationInput.set("selectedStore", selectedStore);
        }
    }

    directionsSummaries_changed() {
        const directionsSummaries = this.get("directionsSummaries");
        this.directions = directionsSummaries;
        this.mainView.onDirectionsChange(directionsSummaries);
        this.directionSlideCurrentIndex = 0;
        this._hydrateDirectionSlider(directionsSummaries[0], 0);
    }

    directionsRenderers_changed() {
        const renderers = this.get("directionsRenderers");
        if (renderers && renderers.length > 0) {
            this._changeDirectionMapDisplayIndex(0);
        }
    }

    /** **********************************************************************************************************
     *                                             Slide edit content                                           *
     *********************************************************************************************************** */

    _hydrateStoreSlider(store) {
        if (store) {
            const storeSliderContainer = this.mainElement.find(".storemap-maplistitem-container");

            // class icon
            const logoItem = this.mainElement.find(".storemap-storelistitem-logo");
            addBrandIconMarker(logoItem[0], store);

            // distance
            if (store.properties.distance) {
                storeSliderContainer.find(".storemap-maplistitem-distance").text(formatStoreDistanceValue(store));
            } else {
                storeSliderContainer.find(".storemap-maplistitem-distance").text("");
            }

            // name

            storeSliderContainer.find(".storemap-maplistitem-storename").text(store.properties.name);

            // open hours
            if (store.properties.open?.open_now) {
                storeSliderContainer.find(".storemap-maplistitem-todayshours").show();
                const hoursText = concatenateStoreHours(store.properties.open.open_hours);

                storeSliderContainer
                    .find(".storemap-maplistitem-todayshours > div")
                    .text(`${total.maps.L10n.ui.common.today} ${hoursText}`);
            } else {
                storeSliderContainer.find(".storemap-maplistitem-todayshours").hide();
            }

            // open 24/7
            $(".storemap-maplistitem-24hours").toggle(open247(store));

            // address
            const address = concatenateStoreAddress(store);

            storeSliderContainer.find(".storemap-maplistitem-infos > div").text(address);

            // phone link

            if (store.properties.contact?.phone) {
                storeSliderContainer
                    .find(".storemap-maplistitem-telephone-link")
                    .prop("href", `tel:${store.properties.contact.phone}`);
            }
        }
    }

    _hydrateDirectionSlider(direction, index) {
        const directionSlideContainer = this.mainElement.find(".storemap-maproaditem-container");
        if (direction) {
            const travelModeIcon = {
                WALKING: "storemap-walk-mode",
                BICYCLING: "storemap-bike-mode",
                DRIVING: "storemap-car-mode",
                TRANSIT: "storemap-bus-mode",
            };

            directionSlideContainer
                .find(".storemap-maproaditem-distance .storemap-icon")
                .removeClass("storemap-walk-mode storemap-bike-mode storemap-car-mode storemap-bus-mode")
                .addClass(travelModeIcon[this.getDirectionTravelMode()]);

            if (direction.summary !== "") {
                directionSlideContainer
                    .find(".storemap-maproaditem-via")
                    .text(`${total.maps.L10n.ui.directions.via} ${direction.summary}`);
            } else {
                directionSlideContainer
                    .find(".storemap-maproaditem-via")
                    .text(`${total.maps.L10n.ui.directions.route} ${Number.parseInt(index, 10) + 1}`);
            }

            const distance = Number.parseFloat(direction.distance.split(" ")[0]) * 1000;

            directionSlideContainer
                .find(".storemap-maproaditem-distance-text")
                .text(`${formatDistanceValue(distance)} - ${direction.durationShort}`);
        }
    }

    _resetStoresOnMapAndSlider() {
        this.storeSlideCurrentIndex = 0;
        this.storesOverlay.setSelection(this.stores[this.storeSlideCurrentIndex]);

        this._hydrateStoreSlider(this.stores[this.storeSlideCurrentIndex]);
        this.set("selectedStore", this.stores[this.storeSlideCurrentIndex]);
        this.mainElement.find(".storemap-maplistitem-container").show();
    }
    showStoresOnRoute(stores) {
        for (const feature of Object.values(this.data._features)) {
            this.data.remove(feature);
        }
        for (const store of stores) {
            this.data.add({
                geometry: new woosmap.map.Data.Point({
                    lat: store.geometry.coordinates[1],
                    lng: store.geometry.coordinates[0],
                }),
                id: store.properties.store_id,
                properties: store.properties,
            });
        }
        this.data.setStyle((feature) => {
            let icon = {
                url: `${SETTINGS.serverUrl}css/images/map-icons/black-dot.svg`,
            };
            const brand = feature.properties.user_properties.brand;
            const poiType = feature.properties.user_properties.poiType;
            if (this.map.getZoom() > SETTINGS.rendererBreakScale && !feature.getProperty("highlighted")) {
                icon = {
                    url: SETTINGS.iconUrls.brand[brand].marker[poiType.toLowerCase()],
                    anchor: poiType === "FUELING" ? new woosmap.map.Point(0, 0) : new woosmap.map.Point(40, 0),
                    scaledSize: new woosmap.map.Size(40, 40),
                };
            }
            if (feature.getProperty("highlighted")) {
                icon = {
                    url: SETTINGS.iconUrls.brand[brand].selectedMarker[poiType.toLowerCase()],
                    anchor: poiType === "FUELING" ? new woosmap.map.Point(0, 0) : new woosmap.map.Point(60, 0),
                    scaledSize: new woosmap.map.Size(60, 60),
                };
            }
            return {
                icon,
            };
        });
        this.data.setMap(this.map);
        this.storesOverlay.setMap(null);
        this.selectFeature();
    }
    selectFeature() {
        let highlightedFeatureId;
        this.data.addListener("click", (event) => {
            if (highlightedFeatureId) {
                const highlightedFeature = this.data.getFeatureById(highlightedFeatureId);

                if (highlightedFeature) {
                    highlightedFeature.setProperty("highlighted", false);
                }
            }
            event.feature.setProperty("highlighted", true);
            highlightedFeatureId = event.feature.id;
            event.feature.toGeoJson((geojson) => {
                this.onStoreSelectedOnRoute(geojson);
            });
        });
    }

    /** **********************************************************************************************************
     *                                             Events                                                       *
     *********************************************************************************************************** */

    onQueryFilterChange(tags, types) {
        this.searchParameters.query = generateSearchQuery().toString();
        this.storesOverlay.setQuery(this.searchParameters.query.toString());
    }

    setSearchBounds(searchBounds) {
        let viewport = new google.maps.LatLngBounds();
        if (searchBounds) {
            viewport = new google.maps.LatLngBounds(
                {
                    lat: searchBounds.south,
                    lng: searchBounds.west,
                },
                {
                    lat: searchBounds.north,
                    lng: searchBounds.east,
                },
            );
        }

        for (const store of this.searchedStores) {
            if (store.properties.distance < 15000) {
                viewport.extend({
                    lat: store.geometry.coordinates[1],
                    lng: store.geometry.coordinates[0],
                });
            }
        }
        if (SERVICE_REGISTRY.locationService.getLocation()) {
            viewport.extend({
                lat: SERVICE_REGISTRY.locationService.getLocation().lat,
                lng: SERVICE_REGISTRY.locationService.getLocation().lng,
            });
        }
        if (this.searchedStores && this.searchedStores.length > 0) {
            this.map.fitBounds(viewport, { left: 100, right: 100 });
        } else {
            this.map.panTo(new woosmap.map.LatLng(SERVICE_REGISTRY.locationService.getLocation()));
        }
    }

    onNearbyStoresChange(stores) {
        this.stores = stores;
        this.searchedStores = stores;
        this.woosmapDistanceProvider.set("location", this.location);

        if (!$.isArray(this.stores) || this.stores.length === 0) {
            this.setStores([]);
            return;
        }
        if (this.stores.length > 5) {
            this.setStores([]);
            return;
        }

        // this.woosmapDistanceProvider.updateStoresDistanceWithGoogle(this.stores, () => {
        //     this._resetStoresOnMapAndSlider();
        // });
        this._resetStoresOnMapAndSlider();
    }
    onItinaryStoresChange(stores) {
        this.stores = stores;

        if (!$.isArray(this.stores) || this.stores.length === 0) {
            this.setStores([]);
            return;
        }
        this.showStoresOnRoute(stores);
        this._resetStoresOnMapAndSlider();
    }

    onLocationChange(location) {
        this.location = location;
        this.location.lat = Number.parseFloat(location.lat);
        this.location.lng = Number.parseFloat(location.lng);

        this.locationMarker.setPosition(this.location);
        this.locationMarker.setMap(this.map);
    }
    onStoreSelectedOnRoute(data) {
        this.selectedStore = data;
        this.selectedStore_changed();
    }
}
